var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "sidebar-wrapper" } }, [
    _c(
      "ul",
      {
        staticClass: "sidebar-nav nav-pills nav-stacked",
        attrs: { id: "menu" }
      },
      [
        _vm._l(_vm.$store.getters.menuArr, function(menuData, index) {
          return [
            _c(
              "li",
              {
                key: index,
                class: "menuCommon " + menuData.slug,
                attrs: { id: menuData.slug }
              },
              [
                menuData.sub_menu == "" || menuData.sub_menu == null
                  ? [
                      menuData.url != null && menuData.url != ""
                        ? [
                            menuData.menu_title.length >= 22
                              ? [
                                  _c(
                                    "a",
                                    {
                                      directives: [
                                        {
                                          name: "b-tooltip",
                                          rawName: "v-b-tooltip.hover",
                                          modifiers: { hover: true }
                                        }
                                      ],
                                      attrs: {
                                        href: menuData.url,
                                        target: "_blank",
                                        title: menuData.menu_title
                                      }
                                    },
                                    [
                                      _c("span", {
                                        class:
                                          "spm-nav-menu " + menuData.icon_url
                                      }),
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(
                                            _vm.stringTrim(
                                              menuData.menu_title,
                                              22
                                            )
                                          ) +
                                          "\n                                "
                                      )
                                    ]
                                  )
                                ]
                              : [
                                  _c(
                                    "a",
                                    {
                                      attrs: {
                                        href: menuData.url,
                                        target: "_blank"
                                      }
                                    },
                                    [
                                      _c("span", {
                                        class:
                                          "spm-nav-menu " + menuData.icon_url
                                      }),
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(menuData.menu_title) +
                                          "\n                                "
                                      )
                                    ]
                                  )
                                ]
                          ]
                        : [
                            menuData.menu_title.length >= 22
                              ? [
                                  _c(
                                    "router-link",
                                    {
                                      directives: [
                                        {
                                          name: "b-tooltip",
                                          rawName: "v-b-tooltip.hover",
                                          modifiers: { hover: true }
                                        }
                                      ],
                                      attrs: {
                                        title: menuData.menu_title,
                                        to: {
                                          name: "CommonPage",
                                          params: { type: menuData.slug }
                                        }
                                      }
                                    },
                                    [
                                      _c("span", {
                                        class:
                                          "spm-nav-menu " + menuData.icon_url
                                      }),
                                      _vm._v(
                                        _vm._s(
                                          _vm.stringTrim(
                                            menuData.menu_title,
                                            22
                                          )
                                        ) + "\n                                "
                                      )
                                    ]
                                  )
                                ]
                              : [
                                  _c(
                                    "router-link",
                                    {
                                      attrs: {
                                        to: {
                                          name: "CommonPage",
                                          params: { type: menuData.slug }
                                        }
                                      }
                                    },
                                    [
                                      true
                                        ? [
                                            [
                                              _c("span", {
                                                class:
                                                  "spm-nav-menu " +
                                                  menuData.icon_url
                                              }),
                                              _vm._v(
                                                _vm._s(menuData.menu_title) +
                                                  "\n                                        "
                                              )
                                            ]
                                          ]
                                        : [
                                            _c("span", {
                                              class:
                                                "spm-nav-menu " +
                                                menuData.icon_url
                                            }),
                                            _vm._v(
                                              _vm._s(menuData.menu_title) +
                                                "\n                                    "
                                            )
                                          ]
                                    ],
                                    2
                                  )
                                ]
                          ]
                    ]
                  : [
                      menuData.url != null && menuData.url != ""
                        ? [
                            menuData.menu_title.length >= 22
                              ? [
                                  _c(
                                    "a",
                                    {
                                      directives: [
                                        {
                                          name: "b-tooltip",
                                          rawName: "v-b-tooltip.hover",
                                          modifiers: { hover: true }
                                        }
                                      ],
                                      attrs: {
                                        title: menuData.menu_title,
                                        href: menuData.url,
                                        target: "_blank"
                                      }
                                    },
                                    [
                                      _c(
                                        "label",
                                        {
                                          staticClass: "tree-toggle nav-header"
                                        },
                                        [
                                          _c("span", {
                                            class:
                                              "spm-nav-menu " +
                                              menuData.icon_url
                                          }),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.stringTrim(
                                                  menuData.menu_title,
                                                  22
                                                )
                                              ) +
                                              "\n                                        "
                                          ),
                                          _c("i", {
                                            staticClass: "fa fa-angle-down",
                                            attrs: { "aria-hidden": "true" }
                                          })
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              : [
                                  _c(
                                    "a",
                                    {
                                      attrs: {
                                        href: menuData.url,
                                        target: "_blank"
                                      }
                                    },
                                    [
                                      _c(
                                        "label",
                                        {
                                          staticClass: "tree-toggle nav-header"
                                        },
                                        [
                                          _c("span", {
                                            class:
                                              "spm-nav-menu " +
                                              menuData.icon_url
                                          }),
                                          _vm._v(
                                            " " +
                                              _vm._s(menuData.menu_title) +
                                              "\n                                        "
                                          ),
                                          _c("i", {
                                            staticClass: "fa fa-angle-down",
                                            attrs: { "aria-hidden": "true" }
                                          })
                                        ]
                                      )
                                    ]
                                  )
                                ]
                          ]
                        : [
                            menuData.menu_title.length >= 22
                              ? [
                                  _c(
                                    "router-link",
                                    {
                                      directives: [
                                        {
                                          name: "b-tooltip",
                                          rawName: "v-b-tooltip.hover",
                                          modifiers: { hover: true }
                                        }
                                      ],
                                      attrs: {
                                        title: menuData.menu_title,
                                        to: {
                                          name: "CommonPage",
                                          params: { type: menuData.slug }
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "label",
                                        {
                                          staticClass: "tree-toggle nav-header"
                                        },
                                        [
                                          _c("span", {
                                            class:
                                              "spm-nav-menu " +
                                              menuData.icon_url
                                          }),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.stringTrim(
                                                  menuData.menu_title,
                                                  22
                                                )
                                              ) +
                                              "\n                                        "
                                          ),
                                          _c("i", {
                                            staticClass: "fa fa-angle-down",
                                            attrs: { "aria-hidden": "true" }
                                          })
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              : [
                                  _c(
                                    "router-link",
                                    {
                                      attrs: {
                                        to: {
                                          name: "CommonPage",
                                          params: { type: menuData.slug }
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "label",
                                        {
                                          staticClass: "tree-toggle nav-header"
                                        },
                                        [
                                          _c("span", {
                                            class:
                                              "spm-nav-menu " +
                                              menuData.icon_url
                                          }),
                                          _vm._v(
                                            " " +
                                              _vm._s(menuData.menu_title) +
                                              "\n                                        "
                                          ),
                                          _c("i", {
                                            staticClass: "fa fa-angle-down",
                                            attrs: { "aria-hidden": "true" }
                                          })
                                        ]
                                      )
                                    ]
                                  )
                                ]
                          ],
                      _vm._v(" "),
                      _c(
                        "ul",
                        { staticClass: "nav nav-list tree" },
                        [
                          _vm._l(menuData.sub_menu, function(
                            subMenuData,
                            index1
                          ) {
                            return [
                              subMenuData.url != null && subMenuData.url != ""
                                ? [
                                    _c(
                                      "li",
                                      {
                                        key: index1,
                                        class: "subMenuLi " + subMenuData.slug
                                      },
                                      [
                                        subMenuData.menu_title.length >= 30
                                          ? [
                                              _c(
                                                "a",
                                                {
                                                  directives: [
                                                    {
                                                      name: "b-tooltip",
                                                      rawName:
                                                        "v-b-tooltip.hover",
                                                      modifiers: { hover: true }
                                                    }
                                                  ],
                                                  attrs: {
                                                    title:
                                                      subMenuData.menu_title,
                                                    href: subMenuData.url,
                                                    target: "_blank"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                               " +
                                                      _vm._s(
                                                        _vm.stringTrim(
                                                          subMenuData.menu_title,
                                                          30
                                                        )
                                                      ) +
                                                      "\n                                            "
                                                  )
                                                ]
                                              )
                                            ]
                                          : [
                                              _c(
                                                "a",
                                                {
                                                  attrs: {
                                                    href: subMenuData.url,
                                                    target: "_blank"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                                " +
                                                      _vm._s(
                                                        subMenuData.menu_title
                                                      ) +
                                                      "\n                                            "
                                                  )
                                                ]
                                              )
                                            ]
                                      ],
                                      2
                                    )
                                  ]
                                : [
                                    _c(
                                      "li",
                                      {
                                        key: index1,
                                        class: "subMenuLi " + subMenuData.slug
                                      },
                                      [
                                        subMenuData.menu_title.length >= 30
                                          ? [
                                              _c(
                                                "router-link",
                                                {
                                                  directives: [
                                                    {
                                                      name: "b-tooltip",
                                                      rawName:
                                                        "v-b-tooltip.hover",
                                                      modifiers: { hover: true }
                                                    }
                                                  ],
                                                  attrs: {
                                                    title:
                                                      subMenuData.menu_title,
                                                    to: {
                                                      name: "CommonPage",
                                                      params: {
                                                        type: subMenuData.slug
                                                      }
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                                " +
                                                      _vm._s(
                                                        _vm.stringTrim(
                                                          subMenuData.menu_title,
                                                          30
                                                        )
                                                      ) +
                                                      "\n                                            "
                                                  )
                                                ]
                                              )
                                            ]
                                          : [
                                              _c(
                                                "router-link",
                                                {
                                                  attrs: {
                                                    to: {
                                                      name: "CommonPage",
                                                      params: {
                                                        type: subMenuData.slug
                                                      }
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                                " +
                                                      _vm._s(
                                                        subMenuData.menu_title
                                                      ) +
                                                      "\n                                            "
                                                  )
                                                ]
                                              )
                                            ]
                                      ],
                                      2
                                    )
                                  ]
                            ]
                          })
                        ],
                        2
                      )
                    ]
              ],
              2
            )
          ]
        }),
        _vm._v(" "),
        _vm._l(_vm.menuArray, function(menu, m_index) {
          return [
            _vm.arrayContainsArray(_vm.loginUserPermission, menu.permissionName)
              ? _c(
                  "li",
                  {
                    key: "m menu " + m_index,
                    class: "menuCommon " + menu.slug,
                    attrs: { id: menu.slug }
                  },
                  [
                    !menu.SubMenu
                      ? [
                          _c(
                            "router-link",
                            { attrs: { to: { name: menu.routerlink.name } } },
                            [
                              _c("span", {
                                class: "spm-nav-menu " + menu.icon
                              }),
                              _vm._v(
                                "\n                            " +
                                  _vm._s(_vm.stringTrim(menu.name, 22)) +
                                  "\n                        "
                              )
                            ]
                          )
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    menu.SubMenu && menu.SubMenu.length > 0
                      ? [
                          _c(
                            "label",
                            { staticClass: "tree-toggle nav-header" },
                            [
                              _c("span", {
                                class: "spm-nav-menu " + menu.icon
                              }),
                              _vm._v(
                                "\n                            " +
                                  _vm._s(menu.name) +
                                  "\n                            "
                              ),
                              _c("i", {
                                staticClass: "fa fa-angle-down",
                                attrs: { "aria-hidden": "true" }
                              })
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "ul",
                            { staticClass: "nav nav-list tree" },
                            [
                              _vm._l(menu.SubMenu, function(
                                submenu,
                                sub_index
                              ) {
                                return [
                                  _vm.arrayContainsArray(
                                    _vm.loginUserPermission,
                                    submenu.permissionName
                                  )
                                    ? _c(
                                        "li",
                                        {
                                          key: "sub " + sub_index,
                                          class: "subMenuLi " + submenu.slug
                                        },
                                        [
                                          _c(
                                            "router-link",
                                            {
                                              attrs: {
                                                to: {
                                                  name: submenu.routerlink.name
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                                        " +
                                                  _vm._s(
                                                    _vm.stringTrim(
                                                      submenu.name,
                                                      30
                                                    )
                                                  ) +
                                                  "\n                                    "
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ]
                              })
                            ],
                            2
                          )
                        ]
                      : _vm._e()
                  ],
                  2
                )
              : _vm._e()
          ]
        })
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-35a79c62", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-35a79c62","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/partials/Sidebar.vue
// module id = null
// module chunks = 